import "core-js/modules/es6.array.find";

/* eslint-disable no-undef */

/* eslint-disable no-unused-vars */
import { NavBar, YouKuVideo, TopButton, Myswiper } from '@/assets/js/emaoZT';
import './css/index.scss';
import '@/assets/js/models/ga-pc';
$(function () {
  $('.advertisement').click(function () {
    var src = $('.advertisement a').attr('href');
    ga('send', 'event', 'gzgjcz-wapguanggaowei', src);
  });
  var navbar = new NavBar();
  var youKuVideo1 = new YouKuVideo('plare', {
    client_id: '0de0da1c389e5881',
    vid: 'XMzQzNDA4MDgyOA=='
  });
  /**
   *  返回顶部
   */

  var topButton = new TopButton('.code-WX');
  /**
   *  轮播图
   */

  var swiper1 = new Myswiper('.tanmi-box');
  var swiper2 = new Myswiper('.fang-cont-box'); // if ($('.tanmi-box .swiper-slide').length > 1) {
  //   const swiper1 = new Swiper('.tanmi-box', {
  //     loop: true,
  //     autoplay: {
  //       delay: 4000,
  //       disableOnInteraction: false
  //     },
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true
  //     },
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev'
  //     },
  //     centeredSlides: true
  //   })
  // }
  // if ($('.fang-cont-box .swiper-slide').length > 1) {
  //   const swiper2 = new Swiper('.fang-cont-box', {
  //     loop: true,
  //     autoplay: {
  //       delay: 4000,
  //       disableOnInteraction: false
  //     },
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true
  //     },
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev'
  //     },
  //     centeredSlides: true
  //   })
  // }

  /**
   * 新闻切换
   */

  $('.xinwen-tab').on('click', 'li', function () {
    $('.xinwen-tab').find('.xinwen-tab-li').removeClass('active');
    $(this).addClass('active');
    var index = $(this).index();
    $('.cont-box').find('.shuoche-cont').eq(index).siblings().addClass('none');
    $('.cont-box').find('.shuoche-cont').eq(index).removeClass('none');
  });
  /**
   * 加载更多
   */

  $('.btn-more').each(function (index) {
    $(this).click(function () {
      var prevObj = $('.cont-box').find('.shuoche-cont').eq(index);

      if (!$(this).get(0).bFlag) {
        $(this).get(0).defaultShow = 6;
        $(this).get(0).bFlag = true;
      }

      var moreObj = prevObj.find('.more-list dl');
      var moreObjLength = moreObj.length;
      $(moreObj.splice(0, $(this).get(0).defaultShow)).show();

      if ($(this).get(0).defaultShow >= moreObjLength) {
        $(this).parent().hide();
        return;
      }

      $(this).get(0).defaultShow = $(this).get(0).defaultShow + $(this).get(0).defaultShow;
    });
  });
});